module.exports = __webpack_public_path__ + "static/service-banner-user-45783f4cf50d1e06e58c2e7773eb8b60.jpeg";